// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsWhatsappResult = objectOf({
  daily_whatsapp_stats: objectOf({
    sent_count_by_hour: arrayOf(arrayOf(number)),
    delivered_count_by_hour: arrayOf(arrayOf(number)),
    failed_count_by_hour: arrayOf(arrayOf(number)),
    read_count_by_hour: arrayOf(arrayOf(number)),
  }),
});
